module.exports = {
  formatDataVersion: function (metadata) {
    if (
      metadata &&
      metadata.version_data_languages &&
      typeof metadata.version_data_languages === 'object' &&
      Object.keys(metadata.version_data_languages).length > 0
    ) {
      return Object.keys(metadata.version_data_languages)
        .sort()
        .map((lang) => `${lang}: ${metadata.version_data_languages[lang]}`)
        .join(' | ')
    }

    if (metadata && metadata.version_data) {
      return metadata.version_data
    }

    return 'Inconnue'
  },
}
